import { render, staticRenderFns } from "./InlineBoxIndicatorRisk.vue?vue&type=template&id=210f961b"
import script from "./InlineBoxIndicatorRisk.vue?vue&type=script&lang=js"
export * from "./InlineBoxIndicatorRisk.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxIndicatorRisk.vue?vue&type=style&index=0&id=210f961b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports